import React from 'react';
import T from 'i18n-react';

const formatDate = (day, month, year) => {

      return `${day}.${month}.${year}`;
    }

const formatTime = (startHours, startMinutes, stopHours, stopMinutes) => {

      return `${startHours}:${startMinutes} - ${stopHours}:${stopMinutes}`;
    };

    const formatTimeTopUp = (startHours, startMinutes, ) => {

          return `${startHours}:${startMinutes}`;
        };


const Tbody = ({list}) => {
    let body;
    if (list) {
         body = list.map((items, index) => {

            if (items.action == "PARKING") {

                let startDate = new Date(items.startDateTime);
                let endDate = new Date(items.endDateTime);
                let amounts = parseFloat(items.amount).toFixed(2) * (-1);
                let startDateText = formatDate(startDate.getDate(), (startDate.getMonth() + 1), startDate.getFullYear());
                let startStopTimeText = formatTime(startDate.getHours(), startDate.getMinutes(), endDate.getHours(), endDate.getMinutes());

                return (
                    <tr key = {index}>
                        <td>{items.licensePlate}</td>
                        <td >{items.parkingZone}</td>
                        <td className="td-amount">
                            <div>- &euro; {amounts}</div>
                            <div>{startDateText}</div>
                            <div>{startStopTimeText}</div>
                        </td>
                </tr>
                )
            }  else if (items.action == "TOPUP")  {

                let startDate = new Date(items.endDateTime);
                let amounts = parseFloat(items.amount).toFixed(2);

                let startDateText = formatDate(startDate.getDate(), (startDate.getMonth() + 1), startDate.getFullYear());
                let startTimeText = formatTimeTopUp(startDate.getHours(), startDate.getMinutes());

                return (
                    <tr key={index}>
                      <td>
                        <T.text tag='span' text="top_up_amount"/>
                      </td>
                      <td></td>
                        <td className="td-amount">
                            <div>&euro; {amounts}</div>
                            <div>{startDateText}</div>
                            <div>{startTimeText}</div>
                        </td>
                </tr>
                )
            }
    });
}

    return (
        <tbody>
            { body }
        </tbody>
)};
export default Tbody;



// WEBPACK FOOTER //
// ./src/components/history/Tbody.js